'use strict';

customerZone.run(['$rootScope', 'Session', '$http', 'config', '$log', 'errorCode',
    function($rootScope, Session, $http, config, $log, errorCode){
        var fetchTransatelPostpaidUsers = function(){
            return $http.get(config.baseUrl + '/data/migrated_postpaids.json')
                .then(function(results){
                    return results.data.msisdn;
                }, unwrapError);
        };

        /**
         * Unwrap given error and map fields if the error contains some using the given mapping.
         */
        // note: this is copy-pasted from RestClientBase.  At some point we might consider moving all this
        // to a RefDataService or something.
        var unwrapError = function(response, mapping){
            if (response.status === -401)
                throw errorCode.wrap(errorCode.SENT_TO_LOGIN);
            else if (response.status <= 0 || response.status === 408)
                throw errorCode.wrap(errorCode.HTTP_CONNECTION_ERROR);
            else if (response.status === 429) {
                throw errorCode.wrap(errorCode.REQUEST_THROTTLED, response.data);
            }
            else if (Math.floor(response.status/100) === 4) {
                if (response.headers('content-type') === 'application/json')
                    throw self.mapFields(response.data, mapping);
                else
                    throw errorCode.wrap(errorCode.CLIENT_ERROR, response.data);
            }
            else {
                throw errorCode.wrap(errorCode.SERVER_ERROR, response.data);
            }
        };

        $rootScope.$on(Session.PROFILE_CHANGED_EVENT, function(){
            fetchTransatelPostpaidUsers().then(function(msisdnArray){
                if (Session.authenticated() && Session.subscriber() &&
                    msisdnArray.includes(Session.subscriber().msisdn)) {
                    Session.flags('postpaid_on_transatel', true);
                }
            })
            .catch(function(error){
                $log.error('Failed to fetch transatel postpaid users', error);
                return [];
            });
        });
    }]);
